import { css } from '@emotion/css'
import { borderRadius, fontSize } from '../../styles'
import getThemeColors, { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'

const styles = {
  table: css({
    width: '100%',
    tableLayout: 'fixed',
    backgroundColor: colors.white,
    borderRadius: borderRadius.default,
    boxShadow: `1px 1px 5px ${hexToRgba(colors.black, 0.1)}`,
    fontSize: fontSize.small,
    borderCollapse: 'collapse',
    borderSpacing: 0,
  }),
}

export default styles

export const rowTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    '& tbody tr:hover': {
      backgroundColor: hexToRgba(themed.light, 0.5),
    },
  })
}
